<template>
  <div>
    <std-fixed v-if="deviceType != 'mobile'"></std-fixed>
    <!-- <bubbleChart></bubbleChart> -->
    <indexContext></indexContext>
  </div>
</template>

<script>
import bubbleChart from "./index/components/bubbleChart";
import indexContext from "./index/components/indexContext"
import StdFixed from "./index/components/stdFixed";
export default {
  name        : "index",
  components  : {StdFixed, indexContext},
  data() {
    return {
      deviceType: window.deviceType || 'pc'
    }
  }
}
</script>

<style lang="less" scoped>
</style>